const API_BASE_URL = process.env.REACT_APP_API_URL;

const MAPFISH_BASE_URL = process.env.REACT_APP_MAPFISH_URL;

const EPSG_IO = 'https://epsg.io';

// Vista 3D (PoC): URLs vazios degradam graciosamente — globo elipsoidal sem
// terreno e sem tileset 3D.
const TERRAIN_URL = process.env.REACT_APP_TERRAIN_URL || '';

const TILES3D_URL = process.env.REACT_APP_3DTILES_URL || '';

// Ferramentas dependentes de interações/overlays OL, sem equivalente na vista
// 3D (PoC) — os botões correspondentes ficam desativados em 3D.
const TOOLS_UNAVAILABLE_IN_3D = [
  'FeatureSearchForm',
  'FeatureEditTools',
  'MeasureTools',
  'PrintMap',
  'PrintRequestList',
  'Geovideo',
];

const Constants = {
  API_BASE_URL,
  MAPFISH_BASE_URL,
  EPSG_IO,
  TERRAIN_URL,
  TILES3D_URL,
  TOOLS_UNAVAILABLE_IN_3D,
};

export default Constants;
